module.exports = __webpack_public_path__ + "assets/img/frame-winner-tablet.e1a6d007.png";